const API = process.env.REACT_APP_BACKEND_URL;

// Map UI method ids to PawaPay Malawi providers
export const PROVIDER_BY_METHOD = {
  airtel: 'AIRTEL_MWI',
  tnm: 'TNM_MWI',
};

export async function createDeposit({ amount, phoneNumber, provider, rideId, userId, description }) {
  const res = await fetch(`${API}/api/pawapay/deposits`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({
      amount: Number(amount),
      phone_number: phoneNumber,
      provider: provider || null,
      ride_id: rideId || null,
      user_id: userId || null,
      description: description || null,
    }),
  });
  const body = await res.json();
  if (!res.ok) throw body;
  return body;
}

export async function getDepositStatus(depositId) {
  const res = await fetch(`${API}/api/pawapay/deposits/${depositId}`);
  const body = await res.json();
  if (!res.ok) throw body;
  return body;
}

export async function createPayout({ amount, phoneNumber, provider, driverId, description }) {
  const res = await fetch(`${API}/api/pawapay/payouts`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({
      amount: Number(amount),
      phone_number: phoneNumber,
      provider,
      driver_id: driverId || null,
      description: description || null,
    }),
  });
  const body = await res.json();
  if (!res.ok) throw body;
  return body;
}

export async function getPayoutStatus(payoutId) {
  const res = await fetch(`${API}/api/pawapay/payouts/${payoutId}`);
  const body = await res.json();
  if (!res.ok) throw body;
  return body;
}

// Poll a deposit until a final status or timeout. Calls onUpdate(status) per tick.
export async function pollDeposit(depositId, { intervalMs = 4000, maxTries = 45, onUpdate } = {}) {
  for (let i = 0; i < maxTries; i++) {
    await new Promise((r) => setTimeout(r, intervalMs));
    let status;
    try {
      const res = await getDepositStatus(depositId);
      status = res.status;
    } catch (e) {
      status = null;
    }
    if (onUpdate) onUpdate(status);
    if (status === 'COMPLETED' || status === 'FAILED' || status === 'IN_RECONCILIATION') {
      return status;
    }
  }
  return 'TIMEOUT';
}
